<div class="flex flex-col">
  <div class="grid grid-cols-2 gap-2 items-center">
    <div>
      <span class="font-semibold">Documents</span>
    </div>
    <div class="flex justify-self-end items-center gap-2">
      <button type="button" mat-button color="primary" (click)="getDocuments(!includeArchived)">{{ includeArchived? 'Hide Archived' : 'Show Archived' }}</button>
    </div>
  </div>

  <mat-table [dataSource]="documentSource" matSort #documentSort="matSort" aria-describedby="documents" class="mat-elevation-z8">
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef mat-sort-header="">Name</mat-header-cell>
      <mat-cell tabindex="0" *matCellDef="let document">
        <span class="mobile-label">Name</span>
        {{ document.name }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="types">
      <mat-header-cell *matHeaderCellDef>Types</mat-header-cell>
      <mat-cell tabindex="0" *matCellDef="let document">
        <span class="mobile-label">Types</span>
        <div class="flex flex-col">
          <div *ngFor="let type of document.types">
            <span>{{ type.type }}</span>
          </div>
        </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="archived">
      <mat-header-cell *matHeaderCellDef>Archived</mat-header-cell>
      <mat-cell tabindex="0" *matCellDef="let document">
        <span class="mobile-label">Archived</span>
        <div class="flex flex-col">
          <span>{{ document.archived? 'Yes' : 'No' }}</span>
        </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell tabindex="0" *matCellDef="let document">
        <div class="flex flex-row justify-start items-center">
          <button type="button" mat-icon-button color="primary" (click)="downloadDocument(document.id, document.name)"
                  matTooltip="Download Document" matTooltipShowDelay="500" matTooltipHideDelay="200">
            <mat-icon>download</mat-icon>
          </button>
          <button type="button" mat-icon-button [color]="document.archived? 'primary' : 'warn'" (click)="archiveDocument(document, !document.archived)"
                  [matTooltip]="document.archived? 'Un-Archive Document' : 'Archive Document'" matTooltipShowDelay="500" matTooltipHideDelay="200">
            <mat-icon *ngIf="!document.archived">archive</mat-icon>
            <mat-icon *ngIf="document.archived">unarchive</mat-icon>
          </button>
          <button *ngIf="!locked" type="button" mat-icon-button color="warn" (click)="deleteDocument(document.id)"
                  matTooltip="Delete Document" matTooltipShowDelay="500" matTooltipHideDelay="200">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="documentColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: documentColumns" class="hover:bg-gray-500 hover:bg-opacity-25"
             [ngClass]="row.archived? 'bg-red-100 bg-opacity-25 text-black' : ''"></mat-row>
  </mat-table>
  <mat-paginator [pageSizeOptions]="[5, 10, 20]" #documentPaginator="matPaginator">
  </mat-paginator>

  <span class="font-semibold mb-2">To add a new document select the requirements met then click upload</span>
  <div class="flex flex-row justify-start items-center gap-4">
    <input type="file" style="display: none;" (change)="uploadDocument($event)" #fileUpload />
    <div class="flex flex-row gap-2">
      <div class="file-upload">
        <button mat-button color="primary" class="upload-btn" (click)="fileUpload.click()" [disabled]="selectedTypes.value.length === 0"
                matTooltip="Download Document" matTooltipShowDelay="500" matTooltipHideDelay="200">
          Select
          <mat-icon>upload</mat-icon>
        </button>
      </div>
    </div>

    <mat-form-field>
      <mat-label>Requirements Met</mat-label>
      <mat-select [formControl]="selectedTypes" multiple>
        <mat-option *ngFor="let type of documentTypes" [value]="type">{{type.type}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
